import React from "react";
import { Col, Form, message, Modal, Row, Skeleton } from "antd";

import FormInput from "components/FormInput/FormInput";
import SectionCard from "components/SectionCard/SectionCard";

import { constructDisplayPercentage } from "utils/general";
import Locale from "react-intl-universal";

const { useForm } = Form;

const ManageAssumptionModal = ({
  defaultValues = {},
  isLoading,
  onOk,
  onCancel,
  visible,
}) => {
  const [form] = useForm();

  const handleOnOkButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();

      const formattedValues = Object.keys(values).reduce(
        (formattedValues, key) => {
          if (values[key]) {
            return {
              ...formattedValues,
              [key]: Number(values[key]) / 100,
            };
          } else {
            return formattedValues;
          }
        },
        values
      );

      onOk(formattedValues);
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  const formatDefaultValues = () => {
    return Object.keys(defaultValues).reduce((formattedDefaultValues, key) => {
      if (defaultValues[key]) {
        return {
          ...formattedDefaultValues,
          [key]: constructDisplayPercentage(defaultValues[key], false),
        };
      } else {
        return formattedDefaultValues;
      }
    }, defaultValues);
  };

  return (
    <Modal
      title={Locale.get("investmentPortfolio.assumptionManagement")}
      visible={visible}
      okText={Locale.get("investmentPortfolio.saveButton")}
      onOk={handleOnOkButtonClick}
      onCancel={onCancel}
      width="50%"
    >
      <Form form={form} initialValues={formatDefaultValues()}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <SectionCard title={Locale.get("investmentPortfolio.assumption")}>
            <Row gutter={16}>
              <Col span={12}>
                <FormInput
                  label={Locale.get("investmentPortfolio.inflationRate")}
                  name="inflation"
                  extraProps={{
                    type: "number",
                    suffix: "%",
                    onPressEnter: handleOnOkButtonClick,
                  }}
                  disabled
                />
              </Col>
              <Col span={12}>
                <FormInput
                  label={Locale.get("investmentPortfolio.unitTrustRate")}
                  name="unitTrust"
                  extraProps={{
                    type: "number",
                    suffix: "%",
                    onPressEnter: handleOnOkButtonClick,
                  }}
                />
              </Col>
              <Col span={12}>
                <FormInput
                  label={Locale.get("investmentPortfolio.epfRate")}
                  name="epf"
                  extraProps={{
                    type: "number",
                    suffix: "%",
                    onPressEnter: handleOnOkButtonClick,
                  }}
                />
              </Col>
              <Col span={12}>
                <FormInput
                  label={Locale.get("investmentPortfolio.shareRate")}
                  name="share"
                  extraProps={{
                    type: "number",
                    suffix: "%",
                    onPressEnter: handleOnOkButtonClick,
                  }}
                />
              </Col>
              <Col span={12}>
                <FormInput
                  label={Locale.get("investmentPortfolio.fdRate")}
                  name="fd"
                  extraProps={{
                    type: "number",
                    suffix: "%",
                    onPressEnter: handleOnOkButtonClick,
                  }}
                />
              </Col>
              <Col span={12}>
                <FormInput
                  label={Locale.get("investmentPortfolio.propertyRate")}
                  name="property"
                  extraProps={{
                    type: "number",
                    suffix: "%",
                    onPressEnter: handleOnOkButtonClick,
                  }}
                />
              </Col>
              <Col span={12}>
                <FormInput
                  label={Locale.get("investmentPortfolio.salaryIncreaseRate")}
                  name="salaryIncrease"
                  extraProps={{
                    type: "number",
                    suffix: "%",
                    onPressEnter: handleOnOkButtonClick,
                  }}
                />
              </Col>
              <Col span={12}>
                <FormInput
                  label={Locale.get("investmentPortfolio.bSavingsCurrent")}
                  name="bankSavings"
                  extraProps={{
                    type: "number",
                    suffix: "%",
                    onPressEnter: handleOnOkButtonClick,
                  }}
                />
              </Col>
            </Row>
          </SectionCard>
        )}
      </Form>
    </Modal>
  );
};

export default ManageAssumptionModal;
